"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CategoriesSectionSkeleton = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _times = _interopRequireDefault(require("es-toolkit/compat/times"));
var _styles = require("../CategoriesSection/styles");
var _TitleSkeleton = require("../TitleSkeleton");
var _constants = require("./constants");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Renders Skeleton for `CategoriesSection`.
 */ const CategoriesSectionSkeleton = (param)=>{
    let { animation = 'pulse', className } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        className: className,
        "data-testid": getTestId(_constants.CATEGORIES_SECTION_SKELETON),
        numberOfSlides: 5,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_TitleSkeleton.TitleSkeleton, {
                animation: animation
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles2.Categories, {
                children: (0, _times.default)(5).map((_, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.CategoryBoxSkeleton, {
                        animation: animation
                    }, "".concat(_presentationComponents.CATEGORY_BOX_SKELETON, "-").concat(index)))
            })
        ]
    });
};
exports.CategoriesSectionSkeleton = CategoriesSectionSkeleton;
